const init = {
    status:false,
    message:'',
    data:{}
}

export const ledgerReducer = (state = init, action) => {
    switch (action.type){
        case 'GET_LEDGER_START':
            return state;
        case 'GET_LEDGER_FAIL':
            return {...state, message:action.payload.message,status:false};
        case 'GET_LEDGER_EXCEPTION':
            return {...state, message:action.payload,status:false};
        case 'GET_LEDGER_SUCCESS':
            return {...state, data:action.payload.data, status:true };
        default:
            return state;
    }
};